
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import "@arctravel/react-fds/lib/index.scss";

const root = createRoot(document.getElementById('root')!);

root.render(
      <App />
);